import React, {
    useEffect
} from "react"
import {
    useLazyGetInstitutionClassesQuery
} from "../Redux/actions/classSetup.action"
import {
    GetCurrentUser
} from "../utils/hooks"
import _ from "lodash"
import { useNavigate, Outlet } from "react-router-dom"




export default function AdmitRoot() {
    const navigate = useNavigate()

    const [getClassesAction, getClassesState] = useLazyGetInstitutionClassesQuery()

    useEffect(() => {
        const user = GetCurrentUser()
        if (user) {
            let user_platform = _.get(user, "meta_data.user_platform", null)
            user_platform && getClassesAction({
                institution_ref: user_platform
            })
            handleNav("classes")
        }
    }, [])


    function handleNav(to) {
        navigate(to)
    }


    return (
        <div className="layout-root">
            <div style={{
                width:"100%",
                height:"90vh",
                paddint:"20px"
            }}>
                <Outlet />
            </div>
        </div>
    )
}